export default __webpack_public_path__ + "static/media/CodeForCauseLogo.99fd0e32.jpg";